/**
 * Get the appropriate pain icon path based on pain scale value
 * @param painValue - Pain scale value (typically 0-10)
 * @param defaultIcon - Default icon path to use when pain value is 0 or null
 * @returns Icon path for the given pain value
 */
export const getPainIcon = (painValue: number | null | undefined, defaultIcon: string = '/assets/icons/pages/nurse/painList/pain-0.svg'): string => {
    if (painValue == null || painValue <= 0) {
        return defaultIcon;
    }

    return `/assets/icons/pages/nurse/painList/pain-${painValue}.svg`;
};

/**
 * Check if a pain value is active (greater than 0)
 * @param painValue - Pain scale value
 * @returns true if pain value is greater than 0
 */
export const isPainActive = (painValue: number | null | undefined): boolean => {
    return painValue != null && painValue > 0;
};
